import { render, staticRenderFns } from "./practicalTestExamDialog.vue?vue&type=template&id=347db44a&scoped=true&"
import script from "./practicalTestExamDialog.vue?vue&type=script&lang=js&"
export * from "./practicalTestExamDialog.vue?vue&type=script&lang=js&"
import style0 from "./practicalTestExamDialog.vue?vue&type=style&index=0&id=347db44a&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "347db44a",
  null
  
)

export default component.exports